// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Autocomplete, TextFieldProps, TextField } from '@mui/material';
import { ICountry } from 'src/utils/countryData';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  countryOptions: ICountry[] | any;
  label: string;
};

type Props = IProps & TextFieldProps;

export default function RHFAutocomplete({
  name,
  countryOptions,
  label,
  ...other
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Autocomplete
            {...field}
            fullWidth
            disablePortal
            ListboxProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
            onChange={(event, newValue) => field.onChange(newValue)}
            options={countryOptions.map((option: any) => option.name)}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  error={!!error}
                  label={label}
                  helperText={error?.message}
                  SelectProps={{
                    autoComplete: 'off',
                  }}
                  FormHelperTextProps={{ style: { marginLeft: 0 } }}
                />
              )
            }}
          />
        )
      }}
    />
  );
}
